import { useEffect, useState } from "react";
import EditComplete from "../EditComplete/EditComplete";
import api from "../../servidor/api";
import "./tabitem.css";

function TabItem(props) {
  const [itens, setItens] = useState([]);
  const [tipo, setTipo] = useState("A");
  const [quantidade, setQuantidade] = useState("");
  const [coditem, setCodItem] = useState(0);
  const [descricao, setDescricao] = useState("");

  const consultarItens = () => {
    if (props.idatividade != 0) {
      api
        .post("v1/consultarItemAtividade", {
          id_visita: props.idvisita,
          id_atividade: props.idatividade,
          id_evidencia: props.idevidencia,
        })
        .then((resposta) => {
          setItens(resposta.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const adicionarItem = () => {
    if (!descricao || !quantidade) {
      alert("Preencha todos os campos!");
      return;
    }

    const novoItem = {
      id_evidencia: props.idevidencia,
      id_visita: props.idvisita,
      id_atividade: props.idatividade,
      id_item: coditem,
      qt: Number(quantidade),
      tipoitem: tipo,
    };

    api
      .post("v1/cadastrarItemAtividade", novoItem)
      .then(() => {
        consultarItens();
      })
      .catch((err) => {
        console.log(err);
      });

    setDescricao("");
    setQuantidade("");
    setTipo("A");
    setCodItem(0);
  };

  const removerItem = (item) => {
    const itemSelecionado = {
      registro: item.reg,
    };

    api
      .post("v1/excluirItemAtividade", itemSelecionado)
      .then(() => {
        consultarItens();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleQuantidadeChange = (e) => {
    const valor = e.target.value.replace(",", ".");
    setQuantidade(valor);
  };

  useEffect(() => {
    consultarItens();
  }, []);

  return (
    <div className="tab-item-card mt-3">
      <div className="tab-item-header">
        <div>
          <h6 className="tab-item-title mb-0">Itens da Atividade</h6>
          <small className="tab-item-subtitle">Materiais, amostras e brindes vinculados à visita</small>
        </div>
        <span className="tab-item-badge">{itens.length} itens</span>
      </div>

      <div className="tab-item-body">
        {itens.length > 0 ? (
          <div className="tab-item-table-wrap">
            <table className="table table-sm table-hover align-middle mb-0 tab-item-table">
              <thead>
                <tr>
                  <th>Item</th>
                  <th className="text-center">Qtde</th>
                  <th className="text-center">Tipo</th>
                  <th className="text-center">Excluir</th>
                </tr>
              </thead>
              <tbody>
                {itens.map((item, index) => (
                  <tr key={index}>
                    <td className="tab-item-produto">{item.produto}</td>
                    <td className="text-center tab-item-quantidade">{item.quantidade}</td>
                    <td className="text-center">
                      <span className="tab-item-tipo">{item.tipo}</span>
                    </td>
                    <td className="text-center">
                      <button
                        disabled={props.disabled}
                        className="btn btn-link text-danger p-0 tab-item-trash"
                        onClick={() => removerItem(item)}
                        title="Excluir"
                      >
                        <i className="bi bi-trash3"></i>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="tab-item-empty">Nenhum item adicionado para esta atividade.</div>
        )}

        {!props.disabled && (
          <div className="tab-item-form">
            <div className="row g-2 align-items-end">
              <div className="col-12 col-lg-2">
                <label htmlFor="amostra" className="tab-item-label mb-1">
                  Tipo
                </label>
                <select
                  id="amostra"
                  className="form-control"
                  value={tipo}
                  onChange={(e) => setTipo(e.target.value)}
                >
                  <option value="">Selecione o tipo</option>
                  <option value="AM">Amostra</option>
                  <option value="MT">Material Técnico</option>
                  <option value="BD">Brinde</option>
                </select>
              </div>

              <div className="col-12 col-lg-6">
                <label htmlFor="Produto" className="tab-item-label mb-1">
                  Item
                </label>
                <EditComplete
                  placeholder={"Informe o item"}
                  id={tipo}
                  onClickCodigo={setCodItem}
                  onClickDescricao={setDescricao}
                  value={descricao}
                />
              </div>

              <div className="col-6 col-lg-2">
                <label htmlFor="Quantidade" className="tab-item-label mb-1">
                  Quantidade
                </label>
                <input
                  type="text"
                  inputMode="decimal"
                  className="form-control"
                  id="Quantidade"
                  placeholder="0"
                  value={quantidade}
                  onChange={handleQuantidadeChange}
                />
              </div>

              <div className="col-6 col-lg-2">
                <button className="btn btn-primary w-100 tab-item-action" onClick={adicionarItem}>
                  Adicionar
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default TabItem;
